import { removeFile } from "./FileSlice";
  
  export function validateFileType(file) {
    return (dispatch) => {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/jpg" &&
        file.type !== "image/bmp" &&
        file.type !== "image/png" &&
        file.type !== "application/pdf" &&
        file.type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        dispatch(removeFile({ name: file.name }));
        throw new Error(
          'Nieprawidłowy format pliku. Plik powinien być zapisany w jednym z poniższych formatów: JPEG, JPG, PNG, BMP, PDF, DOC, DOCX'
        );
      }
    };
  }
  
  // export function validateFileSize(file, maxFileSize) {
  //   return (dispatch) => {
  //     if (file.size > maxFileSize) {
  //       dispatch(removeFile({ name: file.name }));
  //       throw new Error('Maksymalny rozmiar podpinanego pliku wynosi 1 MB!');
  //     }
  //   };
  // }
  export function validateFileSize(file, maxFileSize) {
  
    if (file.size > maxFileSize) {
      throw new Error('Maksymalny rozmiar podpinanego pliku wynosi 5 MB!');
    }
  }
  export function validateFileContent(file) {
    return (dispatch) => {
      if (file.base64 === "data:") {
        dispatch(removeFile({ name: file.name }));
        throw new Error('Podpięty plik jest pusty!');
      }
    };
  }
  
  export function validateThatFileToAddNotExistingInAddedFiles(fileToAdd, files) {
    return (dispatch) => {
      if (files.find((file) => file.name === fileToAdd.name)) {
        dispatch(removeFile({ name: fileToAdd.name }));
        throw new Error('Plik o danej nazwie został już dodany. Zmień nazwę pliku i spróbuj ponownie');
      }
    };
  }
  
  export function validateThatFileToAddNotExceedMaxFilesNumber(files) {
    return (dispatch) => {
      if (files.length === 3) {
        throw new Error('Maksymalna liczba plików możliwych do podpięcia dla pozycji zgłoszenia wynosi 3!');
      }
    };
  }